import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export interface TrashIconProps {
  color?: string;
  height?: number;
  width?: number;
}

export const TrashIcon = ({
  color = "#727272",
  height = 16,
  width = 16,
}: TrashIconProps) => {
  return (
    <div data-testid={applyDataTestId(pom.icons.trashIcon)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M1 3H15"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 1H6.5C5.94772 1 5.5 1.44772 5.5 2V3H10.5V2C10.5 1.44772 10.0523 1 9.5 1Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 11.5V6.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 11.5V6.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5767 14.0827C12.5337 14.6012 12.1003 15 11.58 15H4.42067C3.9004 15 3.46701 14.6012 3.424 14.0827L2.5 3H13.5L12.5767 14.0827Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
